
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[serviceSlug]",
      function () {
        return require("private-next-pages/services/[serviceSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[serviceSlug]"])
      });
    }
  